import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { watchOnce } from '@vueuse/core';
import { getProductPrice } from '~/utils/ProductPrice';
import { isEqual, merge, map } from 'lodash-es';
import sanitizeHtml from 'sanitize-html';
import { useUser } from '~/composables/_next/useUser';
import AzLoader from '~/components/_next/atoms/AzLoader.vue';
import { useIAdvize } from '~/composables/_next/useIAdvize';
import { useProductStore } from '~/composables/_next/stores/useProductStore';
import { useCustomerGroup } from '~/composables/useCustomerGroup';
import useLegacySeoMeta from '~/composables/useLegacySeoMeta';
import { useLocalization } from '~/composables/_next/useLocalization';
import { useCartGetters } from '~/composables/_next/cart/useCartGetters';
import { useSegment } from '~/composables/_next/useSegment';
import { useTrpc } from '~/composables/_next/useTrpc';
import { isOutOfStock } from '~/composables/recipe/utils';
import { getMainImage } from '~/helpers/productCardMethods';
import { cacheControl } from '~/helpers/cacheControl';
import { DOT_SYMBOL, SCHEMA_PRODUCT, NUMBER_OF_REVIEWS } from '~/constants';
import AverageRatingCount from '~/components/Layout/consumerAdvice/AverageRatingCount.vue';
import { gtmValue, gtmDiscountValue, gtmPriceFormat } from '~/helpers/gtm';
import { klaviyoClientPushEvent } from '~/helpers/tracking/klaviyo';
import WishlistButton from '~/components/Product/WishlistButton.vue';
import AddToCartOverlay from '~/components/Layout/Cart/AddToCart/AddToCartOverlay.vue';
import TheTabs from '~/components/Layout/Tabs/TheTabs.vue';
import Gallery from '~/components/Layout/Gallery.vue';
import BaseBreadcrumbs from '~/components/Layout/BaseBreadcrumbs.vue';
import VariantSelector from '~/components/Layout/Cart/AddToCart/VariantSelector.vue';
import AppBottomContent from '~/components/Layout/AppBottomContent.vue';
import HowToUse from '~/components/HowToUse/HowToUse.vue';
import AzEssentialOilGuideCard from '~/components/_next/molecules/AzEssentialOilGuideCard.vue';
import AzBackToTopButton from '~/components/_next/atoms/AzBackToTopButton.vue';
import ShareProduct from '~/components/Product/ShareProduct.vue';
import RatingReviews from '~/components/Layout/consumerAdvice/RatingReviews.vue';
import RichText from '~/components/ui/RichText.vue';
import InformationBox from '~/components/Molecules/InformationBox.vue';
import InformationItem from '~/components/Molecules/InformationItem.vue';
import { ProductKeys, ProductAttributes as ProductEnumsAttributes } from '~/types/ProductEnums';
import { PageTypes } from '~/types/PageTypes';
import { TrackingPageCategory } from '~/types/TrackingPageCategory';
import { isProductExpressDeliveryCompatible, isProductAvailableInCountry, isProductInStock as isVariantInStock } from '~/utils/ProductAvailability';
import TheBibliography from '~/components/ui/TheBibliography.vue';
import ProductLabels from '~/components/Product/ProductLabels.vue';
import MerchandisingLabels from '~/components/Product/MerchandisingLabels.vue';
import BaseSingleBreadcrumb from '~/components/Layout/BaseSingleBreadcrumb.vue';
import { BUNDLE_MERCH_LABEL_KEY } from '~/constants/productsConstants';
import BundleProductCard from '~/components/ui/BundleProductCard.vue';
import KeyBenefits from '~/components/Molecules/KeyBenefits.vue';
import RelatedProductsOrganism from '~/components/_next/organisms/RelatedProductsOrganism.vue';
import RelatedRecipesOrganism from '~/components/_next/organisms/RelatedRecipesOrganism.vue';
import RelatedAdvicesOrganism from '~/components/_next/organisms/RelatedAdvicesOrganism.vue';
import UpsellProductsOrganism from '~/components/_next/organisms/UpsellProductsOrganism.vue';
import AddToCartProductPage from '~/components/Molecules/AddToCartProductPage.vue';
import ProductGallerySkeleton from '~/assets/images/skeletons/product-gallery.svg?inline';
import ProductDescriptionSkeleton from '~/assets/images/skeletons/product-description.svg?inline';
import ProductDescriptionMobileSkeleton from '~/assets/images/skeletons/product-description-mobile.svg?inline';
import ProductImageSkeleton from '~/assets/images/skeletons/product-image.svg?inline';
import { useCustomizer } from '~/composables/_next/stores/useCustomizerStore';
import { useCart } from '~/composables/useCart';
import { DEFAULT_EODP_FR_URL_PARAMETER } from '~/constants/RoutesEnums';
import getImgByLabel from '@/utils/getImgByLabel';
import { isPreview } from '~/utils';
import { getProductAttributes } from '~/utils/commercetools/attributes';
import { useDynamicYield } from '~/composables/_next/useDynamicYield';
export var IProduct;
const __nuxt_page_meta = {
  middleware: [cacheControl('public, s-maxage=1800, stale-while-revalidate=300, stale-if-error=300') // 30 minutes cache and 5 minutes stale
      ],tracking: {
        category: TrackingPageCategory.PDP
      }
}
export default /*#__PURE__*/_defineComponent({
  ...__nuxt_page_meta,__name: '_slug',
  setup: function setup(__props) {
    var _selectedVariant$valu35, _selectedVariant$valu36;
    var route = useRoute();
    var router = useRouter();
    var _useLocalization = useLocalization(),
      country = _useLocalization.country,
      currency = _useLocalization.currency,
      locale = _useLocalization.locale;
    var _useUser = useUser(),
      isAuthenticated = _useUser.isAuthenticated,
      user = _useUser.user,
      userLoading = _useUser.loading;
    var AzExpandableText = function AzExpandableText() {
      return import('~/components/_next/molecules/AzExpandableText.vue');
    };
    ;

    // TODO: Remove after Nuxt 3 migration
    onMounted(function () {
      var _useSegment = useSegment(),
        trackPage = _useSegment.trackPage;
      trackPage(TrackingPageCategory.PDP, PageTypes.PDP);
    });
    var _useCustomizer = useCustomizer(),
      isCustomizerFeatureEnabled = _useCustomizer.isFeatureEnabled;
    var _useNuxt2App = useNuxt2App(),
      app = _useNuxt2App.app,
      error = _useNuxt2App.error,
      i18n = _useNuxt2App.i18n,
      $flag = _useNuxt2App.$flag,
      $trackers = _useNuxt2App.$trackers;
    var _useTrpc = useTrpc(),
      client = _useTrpc.client;
    var _useProductStore = useProductStore(),
      fetchProducts = _useProductStore.fetchProducts,
      fetchProductSeoContent = _useProductStore.fetchProductSeoContent,
      fetchEODPSeoContent = _useProductStore.fetchEODPSeoContent,
      masterVariant = _useProductStore.masterVariant,
      variants = _useProductStore.variants,
      selectedVariant = _useProductStore.selectedVariant,
      selectedVariantPrice = _useProductStore.selectedVariantPrice,
      selectedVariantName = _useProductStore.selectedVariantName,
      selectedVariantDescription = _useProductStore.selectedVariantDescription,
      productSeoContent = _useProductStore.productSeoContent,
      idRawMaterialsReviews = _useProductStore.idRawMaterialsReviews;
    var skusForReviews = computed(function () {
      var _variants$value$map$f, _variants$value, _idRawMaterialsReview;
      var skus = (_variants$value$map$f = (_variants$value = variants.value) === null || _variants$value === void 0 ? void 0 : _variants$value.map(function (v) {
        return v.sku;
      }).filter(Boolean)) !== null && _variants$value$map$f !== void 0 ? _variants$value$map$f : [];
      var skusString = skus.length > 0 ? skus.join(',') : '';
      var idRaw = (_idRawMaterialsReview = idRawMaterialsReviews.value) !== null && _idRawMaterialsReview !== void 0 ? _idRawMaterialsReview : '';
      return [skusString, idRaw].filter(Boolean).join(',');
    });
    var _useCustomerGroup = useCustomerGroup(),
      isCustomerGroupWithoutVat = _useCustomerGroup.isCustomerGroupWithoutVat;
    var masterVariantSku = computed(function () {
      var _masterVariant$value;
      return ((_masterVariant$value = masterVariant.value) === null || _masterVariant$value === void 0 ? void 0 : _masterVariant$value.sku) || '';
    });
    var productId = computed(function () {
      var _masterVariant$value2;
      return ((_masterVariant$value2 = masterVariant.value) === null || _masterVariant$value2 === void 0 ? void 0 : _masterVariant$value2._id) || '';
    });

    // Fetch Product Information (Commercetools) and SEO data from Contentful
    // Note: This is a quick operation that must be performed server side.
    var fetchProductPromise = useLazyAsyncData("fetch-product-".concat(route.params.slug), /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _selectedVariant$valu;
      var _selectedVariant$valu2;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetchProducts();
          case 2:
            if (!(!selectedVariant.value || !((_selectedVariant$valu = selectedVariant.value) !== null && _selectedVariant$valu !== void 0 && _selectedVariant$valu.published) && !isPreview())) {
              _context.next = 5;
              break;
            }
            error({
              statusCode: 404
            });
            return _context.abrupt("return", true);
          case 5:
            if (!(isEssentialOilPage.value && !isEssentialOil.value)) {
              _context.next = 8;
              break;
            }
            error({
              statusCode: 404
            });
            return _context.abrupt("return", true);
          case 8:
            if (!isEssentialOilPage.value) {
              _context.next = 13;
              break;
            }
            _context.next = 11;
            return fetchEODPSeoContent();
          case 11:
            _context.next = 15;
            break;
          case 13:
            _context.next = 15;
            return fetchProductSeoContent();
          case 15:
            updateSeoMeta();
            if (isEssentialOilPage.value) {
              setDynamicYieldContextSSR('OTHER', ['Essential_Oil_Page']);
            } else {
              setDynamicYieldContextSSR('PRODUCT', [(_selectedVariant$valu2 = selectedVariant.value) === null || _selectedVariant$valu2 === void 0 ? void 0 : _selectedVariant$valu2.sku]);
            }
            return _context.abrupt("return", true);
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));

    // Set SEO meta based on the selectedVariant and Contentful SEO fields
    var _useLegacySeoMeta = useLegacySeoMeta(),
      setMeta = _useLegacySeoMeta.setMeta;
    var _useRightPath = useRightPath(),
      getDomain = _useRightPath.getDomain;
    var _useLocalization2 = useLocalization(),
      defaultLocale = _useLocalization2.defaultLocale;
    function getActualPrice(product) {
      var _ref2, _getProductPrice;
      return (_ref2 = ((_getProductPrice = getProductPrice(product)) === null || _getProductPrice === void 0 ? void 0 : _getProductPrice.special) || getProductPrice(product).regular) === null || _ref2 === void 0 ? void 0 : _ref2.toFixed(2);
    }
    var socialMeta = computed(function () {
      var _selectedVariant$valu3, _selectedVariant$valu4, _selectedVariant$valu5, _selectedVariant$valu6, _productSeoContent$va, _productSeoContent$va2, _selectedVariant$valu7, _selectedVariant$valu8, _selectedVariant$valu9, _selectedVariant$valu0, _selectedVariant$valu1, _selectedVariant$valu10, _selectedVariant$valu11, _selectedVariant$valu12;
      if (!((_selectedVariant$valu3 = selectedVariant.value) !== null && _selectedVariant$valu3 !== void 0 && _selectedVariant$valu3._name) || !((_selectedVariant$valu4 = selectedVariant.value) !== null && _selectedVariant$valu4 !== void 0 && (_selectedVariant$valu5 = _selectedVariant$valu4.images) !== null && _selectedVariant$valu5 !== void 0 && (_selectedVariant$valu6 = _selectedVariant$valu5[0]) !== null && _selectedVariant$valu6 !== void 0 && _selectedVariant$valu6.url)) {
        return;
      }
      return [{
        property: 'og:title',
        content: (_productSeoContent$va = (_productSeoContent$va2 = productSeoContent.value) === null || _productSeoContent$va2 === void 0 ? void 0 : _productSeoContent$va2.ogTitle) !== null && _productSeoContent$va !== void 0 ? _productSeoContent$va : (_selectedVariant$valu7 = selectedVariant.value) === null || _selectedVariant$valu7 === void 0 ? void 0 : _selectedVariant$valu7._name
      }, {
        property: 'og:description',
        content: (_selectedVariant$valu8 = selectedVariant.value) === null || _selectedVariant$valu8 === void 0 ? void 0 : _selectedVariant$valu8._description
      }, {
        property: 'og:image',
        content: (_selectedVariant$valu9 = selectedVariant.value) === null || _selectedVariant$valu9 === void 0 ? void 0 : _selectedVariant$valu9.images[0].url
      }, {
        property: 'og:url',
        content: "".concat(getDomain()).concat(route.path)
      }, {
        property: 'twitter:card',
        content: 'summary_large_image'
      }, {
        property: 'twitter:title',
        content: (_selectedVariant$valu0 = selectedVariant.value) === null || _selectedVariant$valu0 === void 0 ? void 0 : _selectedVariant$valu0._name
      }, {
        property: 'og:type',
        content: 'product'
      }, {
        property: 'product:price:amount',
        content: getActualPrice(selectedVariant.value)
      }, {
        property: 'product:price:currency',
        content: (_selectedVariant$valu1 = selectedVariant.value) === null || _selectedVariant$valu1 === void 0 ? void 0 : (_selectedVariant$valu10 = _selectedVariant$valu1.price) === null || _selectedVariant$valu10 === void 0 ? void 0 : (_selectedVariant$valu11 = _selectedVariant$valu10.value) === null || _selectedVariant$valu11 === void 0 ? void 0 : _selectedVariant$valu11.currencyCode
      }, {
        property: 'product:retailer_item_id',
        content: (_selectedVariant$valu12 = selectedVariant.value) === null || _selectedVariant$valu12 === void 0 ? void 0 : _selectedVariant$valu12.sku
      }];
    });
    var _useDynamicYield = useDynamicYield(true),
      setDynamicYieldContext = _useDynamicYield.setDynamicYieldContext,
      setDynamicYieldContextSSR = _useDynamicYield.setDynamicYieldContextSSR,
      trackDynamicYieldEvent = _useDynamicYield.trackDynamicYieldEvent;
    var _useProductStore2 = useProductStore(),
      fetchProductContent = _useProductStore2.fetchProductContent,
      productContent = _useProductStore2.productContent,
      relatedRecipes = _useProductStore2.relatedRecipes,
      relatedRecipesDescription = _useProductStore2.relatedRecipesDescription,
      relatedProductDescription = _useProductStore2.relatedProductDescription,
      relatedProductsSku = _useProductStore2.relatedProductsSku,
      relatedAdvices = _useProductStore2.relatedAdvices,
      isEssentialOil = _useProductStore2.isEssentialOil,
      isEssentialOilPage = _useProductStore2.isEssentialOilPage;
    function updateSeoMeta() {
      var _selectedVariant$valu13, _selectedVariant$valu14, _selectedVariant$valu15, _selectedVariant$valu16;
      var productTitle = (_selectedVariant$valu13 = selectedVariant.value) === null || _selectedVariant$valu13 === void 0 ? void 0 : _selectedVariant$valu13._name;
      var productCategoriesSlugs = (_selectedVariant$valu14 = selectedVariant.value) === null || _selectedVariant$valu14 === void 0 ? void 0 : (_selectedVariant$valu15 = _selectedVariant$valu14._categories) === null || _selectedVariant$valu15 === void 0 ? void 0 : _selectedVariant$valu15.map(function (_ref3) {
        var slug = _ref3.slug;
        return slug;
      });
      var fallbackEogCanonical = locale === defaultLocale && useHasEssentialOilsCategory(productCategoriesSlugs) ? {
        canonical: "".concat(getDomain()).concat(route.path).concat(DEFAULT_EODP_FR_URL_PARAMETER)
      } : {};
      var seoFallback = productTitle ? {
        title: productTitle,
        description: i18n.t('seo.product.description', {
          name: productTitle
        })
      } : {};
      var seo = Object.assign({}, fallbackEogCanonical, seoFallback, productSeoContent.value, {
        slug: (_selectedVariant$valu16 = selectedVariant.value) === null || _selectedVariant$valu16 === void 0 ? void 0 : _selectedVariant$valu16._allSlugs
      }, {
        socialMeta: socialMeta.value
      }, {
        hreflangOverrides: {
          it: {
            pathPrefix: isEssentialOil.value ? '/it/guide/$[param]' : undefined
          },
          de: {
            pathPrefix: isEssentialOil.value ? '/de/guide/$[param]' : undefined
          },
          en: {
            pathPrefix: isEssentialOil.value ? '/en/guide/$[param]' : undefined
          },
          es: {
            pathPrefix: isEssentialOil.value ? '/es/guide/$[param]' : undefined
          },
          fr: {
            pathPrefix: isEssentialOil.value ? '/info/fiche-technique/$[param]?page=library' : undefined
          }
        }
      });
      // Note that meta tags are appended to the head of the page from the default layout.
      setMeta(seo);
    }

    // Refresh SEO data when the selected variant changes
    watch(selectedVariant, function () {
      var _selectedVariant$valu17;
      updateSeoMeta();
      if (isEssentialOilPage.value) {
        setDynamicYieldContext('OTHER', ['Essential_Oil_Page']);
      } else if ((_selectedVariant$valu17 = selectedVariant.value) !== null && _selectedVariant$valu17 !== void 0 && _selectedVariant$valu17.sku) {
        var _selectedVariant$valu18;
        setDynamicYieldContext('PRODUCT', [(_selectedVariant$valu18 = selectedVariant.value) === null || _selectedVariant$valu18 === void 0 ? void 0 : _selectedVariant$valu18.sku]);
      }
    }, {
      immediate: false
    });

    // Fetch Product Content (Contentful)
    var _useLazyAsyncData = useLazyAsyncData("fetch-product-content-".concat(route.params.slug), /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return fetchProductContent();
            case 2:
              return _context2.abrupt("return", true);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))),
      contentLoading = _useLazyAsyncData.pending;
    var formattedTitle = computed(function () {
      var _productContent$value, _productContent$value2, _productContent$value3, _productContent$value4;
      return isEssentialOilPage.value ? "".concat((_productContent$value = productContent.value) === null || _productContent$value === void 0 ? void 0 : _productContent$value.preTitle).concat((_productContent$value2 = productContent.value) === null || _productContent$value2 === void 0 ? void 0 : _productContent$value2.title) : (_productContent$value3 = (_productContent$value4 = productContent.value) === null || _productContent$value4 === void 0 ? void 0 : _productContent$value4.title) !== null && _productContent$value3 !== void 0 ? _productContent$value3 : selectedVariantName.value;
    });
    var tabs = computed(function () {
      var _productContent$value5;
      return (_productContent$value5 = productContent.value) === null || _productContent$value5 === void 0 ? void 0 : _productContent$value5.tabs;
    });
    var bottomContent = computed(function () {
      var _productContent$value6;
      return (_productContent$value6 = productContent.value) === null || _productContent$value6 === void 0 ? void 0 : _productContent$value6.bottomContent;
    });

    // Product bundle data
    var _useProductStore3 = useProductStore(),
      bundleData = _useProductStore3.bundleData,
      bundleVariant = _useProductStore3.bundleVariant,
      isBundle = _useProductStore3.isBundle;

    // Fetch product reviews
    var _useProductStore4 = useProductStore(),
      productReviews = _useProductStore4.productReviews,
      fetchProductReviews = _useProductStore4.fetchProductReviews;
    useLazyAsyncData("fetch-product-reviews-".concat(route.params.slug), /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!process.client) {
              _context3.next = 2;
              break;
            }
            return _context3.abrupt("return", true);
          case 2:
            if (!(fetchProductPromise.status.value === 'pending')) {
              _context3.next = 5;
              break;
            }
            _context3.next = 5;
            return fetchProductPromise;
          case 5:
            _context3.next = 7;
            return fetchProductReviews();
          case 7:
            return _context3.abrupt("return", true);
          case 8:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })));
    var reviewsTotalReviews = computed(function () {
      var _selectedVariant$valu19, _selectedVariant$valu20, _selectedVariant$valu21;
      return (_selectedVariant$valu19 = selectedVariant.value) !== null && _selectedVariant$valu19 !== void 0 && (_selectedVariant$valu20 = _selectedVariant$valu19._rating) !== null && _selectedVariant$valu20 !== void 0 && _selectedVariant$valu20.count ? (_selectedVariant$valu21 = selectedVariant.value) === null || _selectedVariant$valu21 === void 0 ? void 0 : _selectedVariant$valu21._rating.count : 0;
    });
    var reviewsTotalLocalReviews = computed(function () {
      var _productReviews$value, _productReviews$value2;
      return (_productReviews$value = productReviews.value) !== null && _productReviews$value !== void 0 && _productReviews$value.total ? (_productReviews$value2 = productReviews.value) === null || _productReviews$value2 === void 0 ? void 0 : _productReviews$value2.total : 0;
    });
    var reviewsAverageRating = computed(function () {
      var _selectedVariant$valu22, _selectedVariant$valu23;
      return ((_selectedVariant$valu22 = selectedVariant.value) === null || _selectedVariant$valu22 === void 0 ? void 0 : (_selectedVariant$valu23 = _selectedVariant$valu22._rating) === null || _selectedVariant$valu23 === void 0 ? void 0 : _selectedVariant$valu23.averageRating) || 0;
    });

    // ====== LEGACY CODE ========

    var items = ref('');
    var _useUiState = useUiState(),
      hideCartPopup = _useUiState.hideCartPopup,
      toggleCartSidebar = _useUiState.toggleCartSidebar;
    var _useCart = useCart(),
      cart = _useCart.cart,
      countItemsWithoutGift = _useCart.countItemsWithoutGift;
    var _useCartGetters = useCartGetters(),
      getTotals = _useCartGetters.getTotals;
    var _useMobileObserver = useMobileObserver(),
      isMobileView = _useMobileObserver.isMobile;
    var isBookShop = computed(function () {
      if (_typeof(selectedVariant.value) !== 'object' || selectedVariant.value === null) {
        return false;
      }
      var hasRdvBookshop = selectedVariant.value._ProductType === ProductEnumsAttributes.workshop;
      return hasRdvBookshop;
    });
    var qty = ref(1);
    var customizerNeutralBase = computed(function () {
      var _productContent$value7, _productContent$value8;
      return (_productContent$value7 = productContent.value) === null || _productContent$value7 === void 0 ? void 0 : (_productContent$value8 = _productContent$value7.customizerNeutralBase) === null || _productContent$value8 === void 0 ? void 0 : _productContent$value8.fields;
    });
    var _useGetBreadcrumbs = useGetBreadcrumbs(),
      getProductBreadcrumbs = _useGetBreadcrumbs.getProductBreadcrumbs;
    var freeShippingThreshold = useState('free-shipping-threshold', function () {
      return null;
    });
    var shippingMethodsByLocation = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _filteredZoneRates$, _filteredZoneRates$$s, res, standardOrExpressMethod, desiredMethod, filteredZoneRates;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return client.shippingMethods.getShippingMethodsByLocation.query({
                country: country
              });
            case 3:
              res = _context4.sent;
              standardOrExpressMethod = res.shippingMethodsByLocation.filter(function (item) {
                return item.name === 'Standard' || item.name === 'Express';
              });
              desiredMethod = standardOrExpressMethod.find(function (item) {
                return item.name === 'Standard';
              }) || standardOrExpressMethod[0];
              filteredZoneRates = desiredMethod === null || desiredMethod === void 0 ? void 0 : desiredMethod.zoneRates.filter(function (zoneRate) {
                return zoneRate.shippingRates.some(function (shippingRate) {
                  return shippingRate.isMatching;
                });
              });
              freeShippingThreshold.value = (_filteredZoneRates$ = filteredZoneRates[0]) === null || _filteredZoneRates$ === void 0 ? void 0 : (_filteredZoneRates$$s = _filteredZoneRates$.shippingRates[0]) === null || _filteredZoneRates$$s === void 0 ? void 0 : _filteredZoneRates$$s.freeAbove;
              _context4.next = 13;
              break;
            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4["catch"](0);
              console.error('Error during get shipping methods', _context4.t0);
            case 13:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 10]]);
      }));
      return function shippingMethodsByLocation() {
        return _ref6.apply(this, arguments);
      };
    }();

    // to be added on local useStore factory
    var isAddToCartModalOpen = ref(false);
    var toggleAddToCartModal = function toggleAddToCartModal() {
      if (useIsMobile()) {
        isAddToCartModalOpen.value = !isAddToCartModalOpen.value;
      }
    };
    var addToCartPopup = function addToCartPopup(_ref7) {
      var dataWorkshop = _ref7.dataWorkshop,
        ProductQty = _ref7.ProductQty;
      if (typeof ProductQty === 'number') qty.value = ProductQty;
      if (Array.isArray(dataWorkshop)) items.value = dataWorkshop;
      isAddToCartModalOpen.value = !isAddToCartModalOpen.value;
    };
    var isSticky = ref(false);
    var isStickyDesktop = ref(false);
    var refHookStickyAddToCartDesktop = ref(null);
    var refAddToCartPDP = ref(null);

    /**
     * Track a "view_item" event for a selected product variant
     *
     * @param {Object} params - Tracking parameters
     * @param {any} params.variant - The selected variant
     * @param {string} params.variantName - Display name of the variant
     * @param {number} params.priceRegular - Base product price
     * @param {number} [params.priceSpecial] - Discounted product price
     * @param {number} [params.qty=1] - Quantity being viewed
     */

    function trackViewItem(_ref8) {
      var _variant$price, _variant$price$value, _variant$price2, _variant$price2$value;
      var variant = _ref8.variant,
        variantName = _ref8.variantName,
        priceRegular = _ref8.priceRegular,
        priceSpecial = _ref8.priceSpecial,
        _ref8$qty = _ref8.qty,
        qty = _ref8$qty === void 0 ? 1 : _ref8$qty;
      var value = gtmValue(priceRegular, priceSpecial, false, qty);
      var valueInCents = gtmValue(priceRegular, priceSpecial, true, qty);
      var item = {
        item_id: "SKU_".concat(variant === null || variant === void 0 ? void 0 : variant.sku),
        item_sku: variant === null || variant === void 0 ? void 0 : variant.sku,
        item_name: variantName,
        discount: gtmDiscountValue(priceRegular, priceSpecial, false),
        discount_in_cents: gtmDiscountValue(priceRegular, priceSpecial, true),
        price: gtmPriceFormat(priceRegular),
        price_in_cents: gtmPriceFormat(priceRegular, true),
        is_master_in_front: variant === null || variant === void 0 ? void 0 : variant._master,
        is_in_stock: !isOutOfStock(variant),
        currency: variant === null || variant === void 0 ? void 0 : (_variant$price = variant.price) === null || _variant$price === void 0 ? void 0 : (_variant$price$value = _variant$price.value) === null || _variant$price$value === void 0 ? void 0 : _variant$price$value.currencyCode,
        ct_product_id: variant === null || variant === void 0 ? void 0 : variant._id
      };
      $trackers.gtm.pushEvent('view_item', {
        event: 'view_item',
        event_category: 'ecommerce',
        event_action: 'open',
        event_label: variantName,
        event_name: 'view_item',
        ecommerce: {
          value: value,
          value_in_cents: valueInCents,
          currency: variant === null || variant === void 0 ? void 0 : (_variant$price2 = variant.price) === null || _variant$price2 === void 0 ? void 0 : (_variant$price2$value = _variant$price2.value) === null || _variant$price2$value === void 0 ? void 0 : _variant$price2$value.currencyCode,
          items: [item]
        }
      });
    }
    var observerForCtaStickyMobile;
    var observerForCtaStickyDesktop;
    function initIntersectionObserver() {
      observerForCtaStickyMobile = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            isSticky.value = true;
          } else {
            isSticky.value = false;
          }
        });
      }, {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshold: 0.5
      });
      observerForCtaStickyDesktop = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            isStickyDesktop.value = true;
          } else {
            isStickyDesktop.value = false;
          }
        });
      }, {
        threshold: 1.0
      });
    }
    onMounted(function () {
      window.scrollTo(0, 0);
      initIntersectionObserver();
    });
    watch(refAddToCartPDP, function (val) {
      if (val) {
        observerForCtaStickyMobile.observe(val);
      }
    }, {
      once: true
    });
    watch(refHookStickyAddToCartDesktop, function (val) {
      if (val) {
        observerForCtaStickyDesktop.observe(val);
      }
    }, {
      once: true
    });
    onUnmounted(function () {
      if (observerForCtaStickyMobile) {
        observerForCtaStickyMobile.disconnect();
      }
      if (observerForCtaStickyDesktop) {
        observerForCtaStickyDesktop.disconnect();
      }
    });
    var customerEmail = computed(function () {
      var _user$value;
      return isAuthenticated.value ? user === null || user === void 0 ? void 0 : (_user$value = user.value) === null || _user$value === void 0 ? void 0 : _user$value.email : '';
    });
    var priceRegular = computed(function () {
      return getProductPrice(selectedVariant.value).regular;
    });
    var priceSpecial = computed(function () {
      return getProductPrice(selectedVariant.value).special;
    });
    var options = computed(function () {
      return getProductAttributes(variants.value, ['color', 'capacity', 'capacity-unit', 'capacity-type']);
    });
    var configuration = computed(function () {
      return Object.keys(selectedVariant.value).length !== 0 ? getProductAttributes(selectedVariant.value, ['color', 'capacity', 'capacity-unit', 'capacity-type']) : {};
    });
    var inStockAttribute = computed(function () {
      var _selectedVariant$valu24, _selectedVariant$valu25;
      return (_selectedVariant$valu24 = selectedVariant.value) === null || _selectedVariant$valu24 === void 0 ? void 0 : (_selectedVariant$valu25 = _selectedVariant$valu24.attributesRaw) === null || _selectedVariant$valu25 === void 0 ? void 0 : _selectedVariant$valu25.find(function (attribute) {
        return attribute.name === 'is-sellable';
      });
    });
    var isProductDiscontinuedAttribute = computed(function () {
      var _selectedVariant$valu26, _selectedVariant$valu27;
      return (_selectedVariant$valu26 = selectedVariant.value) === null || _selectedVariant$valu26 === void 0 ? void 0 : (_selectedVariant$valu27 = _selectedVariant$valu26.attributesRaw) === null || _selectedVariant$valu27 === void 0 ? void 0 : _selectedVariant$valu27.find(function (attribute) {
        return attribute.name === 'is-product-discontinued';
      });
    });
    var isInStock = computed(function () {
      var _inStockAttribute$val;
      return ((_inStockAttribute$val = inStockAttribute.value) === null || _inStockAttribute$val === void 0 ? void 0 : _inStockAttribute$val.value.key) !== 'OutOfStock';
    });
    var isDiscontinued = computed(function () {
      var _inStockAttribute$val2;
      return ((_inStockAttribute$val2 = inStockAttribute.value) === null || _inStockAttribute$val2 === void 0 ? void 0 : _inStockAttribute$val2.value.key) === ProductKeys.discontinued;
    });
    var isProductDiscontinued = computed(function () {
      var _isProductDiscontinue;
      return !!((_isProductDiscontinue = isProductDiscontinuedAttribute.value) !== null && _isProductDiscontinue !== void 0 && _isProductDiscontinue.value);
    });
    var isAvailableInCountry = computed(function () {
      return isProductAvailableInCountry(selectedVariant.value, country);
    });
    var isExpressDeliveryUnavailable = computed(function () {
      return !isProductExpressDeliveryCompatible(selectedVariant.value, country);
    });
    var breadcrumbs = computed(function () {
      if (isEssentialOilPage.value) {
        var _productContent$value9;
        return [{
          link: app.localePath({
            name: 'index'
          }),
          text: i18n.t('utils.homeBreadcrumbs')
        }, {
          link: app.localePath({
            name: 'guides'
          }),
          text: i18n.t('eolp.breadcrumb')
        }, {
          link: app.localePath({
            name: 'guide-slug',
            params: {
              slug: route.params.slug
            }
          }),
          text: (_productContent$value9 = productContent.value) === null || _productContent$value9 === void 0 ? void 0 : _productContent$value9.title
        }];
      }
      return getProductBreadcrumbs(selectedVariant.value);
    });
    var merchLabels = computed(function () {
      var _selectedVariant$valu28, _selectedVariant$valu29;
      if (isEssentialOilPage.value) {
        return {
          category: i18n.t('eogdp.merchLabel')
        };
      }
      var labels = {};
      if (isBundle.value) {
        labels[BUNDLE_MERCH_LABEL_KEY] = bundleData.value.label;
      }
      (_selectedVariant$valu28 = selectedVariant.value) === null || _selectedVariant$valu28 === void 0 ? void 0 : (_selectedVariant$valu29 = _selectedVariant$valu28.attributesRaw) === null || _selectedVariant$valu29 === void 0 ? void 0 : _selectedVariant$valu29.forEach(function (attribute) {
        if (attribute.name === 'best-seller' || attribute.name === 'usage-type') {
          if (attribute.value === true) {
            labels[attribute.name] = 'bestSeller';
          } else {
            var _attribute$value, _attribute$value$labe;
            labels[attribute.name] = (_attribute$value = attribute.value) === null || _attribute$value === void 0 ? void 0 : (_attribute$value$labe = _attribute$value.label) === null || _attribute$value$labe === void 0 ? void 0 : _attribute$value$labe[locale];
          }
        }
      });
      return labels;
    });
    var totalCart = computed(function () {
      return getTotals(cart.value);
    });
    var freeShippingRemainingAmount = computed(function () {
      var _freeShippingThreshol, _totalCart$value;
      if (!freeShippingThreshold.value) return null;
      var remainingAmount = ((_freeShippingThreshol = freeShippingThreshold.value) === null || _freeShippingThreshol === void 0 ? void 0 : _freeShippingThreshol.centAmount) / 100 - ((_totalCart$value = totalCart.value) === null || _totalCart$value === void 0 ? void 0 : _totalCart$value.total);
      return remainingAmount > 0 ? remainingAmount : null;
    });
    var freeShippingThresholdReached = computed(function () {
      var _freeShippingThreshol2;
      var threshold = ((_freeShippingThreshol2 = freeShippingThreshold.value) === null || _freeShippingThreshol2 === void 0 ? void 0 : _freeShippingThreshol2.centAmount) / 100;
      return totalCart.value.special >= threshold;
    });
    var freeShippingProduct = computed(function () {
      if (!freeShippingThreshold.value) return false;
      var threshold = freeShippingThreshold.value.centAmount;
      var effectivePrice = priceSpecial.value ? priceSpecial.value * 100 : priceRegular.value * 100;
      return effectivePrice >= threshold;
    });
    var freeShippingText = computed(function () {
      if (freeShippingProduct.value && !freeShippingThresholdReached.value) {
        return i18n.t('pdp.freeShippingProduct');
      } else if (freeShippingThresholdReached.value) {
        return i18n.t('pdp.freeShippingReached');
      } else if (freeShippingRemainingAmount.value != null) {
        return i18n.t('pdp.freeShippingRemainingAmount', {
          remainingAmount: i18n.n(freeShippingRemainingAmount.value, {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
          })
        });
      }
    });
    var hasLabels = computed(function () {
      return !!Object.keys(merchLabels.value).length;
    });
    var isCustomizable = computed(function () {
      var _selectedVariant$valu30, _selectedVariant$valu31, _selectedVariant$valu32, _selectedVariant$valu33, _selectedVariant$valu34;
      if (!customizerNeutralBase.value) return false;
      var customizerVariant = (_selectedVariant$valu30 = selectedVariant.value) === null || _selectedVariant$valu30 === void 0 ? void 0 : (_selectedVariant$valu31 = _selectedVariant$valu30._original) === null || _selectedVariant$valu31 === void 0 ? void 0 : (_selectedVariant$valu32 = _selectedVariant$valu31.masterData) === null || _selectedVariant$valu32 === void 0 ? void 0 : (_selectedVariant$valu33 = _selectedVariant$valu32.current) === null || _selectedVariant$valu33 === void 0 ? void 0 : (_selectedVariant$valu34 = _selectedVariant$valu33.allVariants) === null || _selectedVariant$valu34 === void 0 ? void 0 : _selectedVariant$valu34.find(function (i) {
        return i.sku === customizerNeutralBase.value.productSku;
      });
      if (!customizerVariant) return false;
      return isInStock.value && isVariantInStock(customizerVariant) && isCustomizerFeatureEnabled;
    });
    var defaultProductImage = computed(function () {
      var _variants$value2, _variants$value2$, _variants$value2$$ima, _variants$value2$$ima2;
      return (_variants$value2 = variants.value) === null || _variants$value2 === void 0 ? void 0 : (_variants$value2$ = _variants$value2[0]) === null || _variants$value2$ === void 0 ? void 0 : (_variants$value2$$ima = _variants$value2$.images) === null || _variants$value2$$ima === void 0 ? void 0 : (_variants$value2$$ima2 = _variants$value2$$ima[0]) === null || _variants$value2$$ima2 === void 0 ? void 0 : _variants$value2$$ima2.url;
    });
    var getProductMainImage = computed(function () {
      var _variants$value3;
      return getMainImage((_variants$value3 = variants.value) === null || _variants$value3 === void 0 ? void 0 : _variants$value3[0]);
    });
    var relatedRecipesEl = ref(null);
    var scrollToRecipes = function scrollToRecipes() {
      window.scrollTo({
        top: relatedRecipesEl.value.$el.offsetTop,
        left: 0,
        behavior: 'smooth'
      });
    };
    var getLabel = function getLabel(availableOptions, currentOption, attribute) {
      var _availableOptions$val, _availableOptions$val2, _availableOptions$val3;
      return ((_availableOptions$val = availableOptions.value) === null || _availableOptions$val === void 0 ? void 0 : (_availableOptions$val2 = _availableOptions$val[attribute]) === null || _availableOptions$val2 === void 0 ? void 0 : (_availableOptions$val3 = _availableOptions$val2.find(function (att) {
        var _currentOption$value;
        return (att === null || att === void 0 ? void 0 : att.value) === (currentOption === null || currentOption === void 0 ? void 0 : (_currentOption$value = currentOption.value) === null || _currentOption$value === void 0 ? void 0 : _currentOption$value[attribute]);
      })) === null || _availableOptions$val3 === void 0 ? void 0 : _availableOptions$val3.label) || '';
    };
    var ecoPart = (_selectedVariant$valu35 = selectedVariant.value) === null || _selectedVariant$valu35 === void 0 ? void 0 : (_selectedVariant$valu36 = _selectedVariant$valu35.attributesRaw) === null || _selectedVariant$valu36 === void 0 ? void 0 : _selectedVariant$valu36.find(function (item) {
      return item.name === 'eco-part';
    });
    var generateVariantString = function generateVariantString() {
      if (ecoPart !== null && ecoPart !== void 0 && ecoPart.value && (ecoPart === null || ecoPart === void 0 ? void 0 : ecoPart.value) > 0) {
        return i18n.t('pdp.eco-part', {
          amount: i18n.n(ecoPart.value, {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
          })
        });
      }
      var capacity = getLabel(options, configuration, 'capacity');
      var unit = getLabel(options, configuration, 'capacity-unit');
      var type = getLabel(options, configuration, 'capacity-type');
      var color = getLabel(options, configuration, 'color');
      var separator = " ".concat(DOT_SYMBOL, " ");
      if (isBundle.value) {
        return i18n.tc('addToCart.articles', bundleData === null || bundleData === void 0 ? void 0 : bundleData.value.count);
      }
      return capacity + unit + (type ? separator : '') + type + (color && capacity ? separator : '') + color;
    };
    var portionLabel = computed(function () {
      var capacity = getLabel(options, configuration, 'capacity');
      var unit = getLabel(options, configuration, 'capacity-unit');
      return i18n.tc('addToCart.articleToPortion', capacity === null || capacity === void 0 ? void 0 : capacity.length, {
        capacity: capacity,
        unit: unit
      });
    });
    var isPortionLabelVisible = computed(function () {
      var _options$value, _options$value$capaci;
      return portionLabel.value && ((_options$value = options.value) === null || _options$value === void 0 ? void 0 : (_options$value$capaci = _options$value.capacity) === null || _options$value$capaci === void 0 ? void 0 : _options$value$capaci.length) < 2;
    });
    var pricePerUnit = computed(function () {
      var capacity = getLabel(options, configuration, 'capacity');
      var unit = getLabel(options, configuration, 'capacity-unit');
      if (capacity && unit) {
        var productPriceRegular = parseFloat(priceRegular.value);
        var productPriceSpecial = parseFloat(priceSpecial.value);
        var priceMultiplier = 1;
        var baseUnit = unit;
        switch (unit) {
          case 'ml':
            priceMultiplier = 1000;
            baseUnit = unit.slice(1, 2);
            break;
          case 'g':
            priceMultiplier = 1000;
            break;
          case 'kg':
            baseUnit = unit.slice(1, 2);
            break;
        }
        var pricePerUnitRegular = 1 / capacity * priceMultiplier * productPriceRegular;
        var roundedPriceRegular = +pricePerUnitRegular.toFixed(2);
        var pricePerUnitSpecial = 1 / capacity * priceMultiplier * productPriceSpecial;
        var roundedPriceSpecial = +pricePerUnitSpecial.toFixed(2);
        return {
          baseUnit: baseUnit,
          priceRegular: roundedPriceRegular,
          priceSpecial: roundedPriceSpecial
        };
      }
    });
    var productsVariants = function productsVariants() {
      return variants.value.map(function (product) {
        var _product$attributesRa, _product$attributesRa2, _product$attributesRa3, _product$attributesRa4, _product$attributesRa5, _product$attributesRa6, _product$attributesRa7;
        var existingVariants = {
          'capacity': (_product$attributesRa = product.attributesRaw.find(function (attribute) {
            return attribute.name === 'capacity';
          })) === null || _product$attributesRa === void 0 ? void 0 : _product$attributesRa.value,
          'capacity-unit': (_product$attributesRa2 = product.attributesRaw.find(function (attribute) {
            return attribute.name === 'capacity-unit';
          })) === null || _product$attributesRa2 === void 0 ? void 0 : (_product$attributesRa3 = _product$attributesRa2.value) === null || _product$attributesRa3 === void 0 ? void 0 : _product$attributesRa3.key,
          'color': (_product$attributesRa4 = product.attributesRaw.find(function (attribute) {
            return attribute.name === 'color';
          })) === null || _product$attributesRa4 === void 0 ? void 0 : (_product$attributesRa5 = _product$attributesRa4.value) === null || _product$attributesRa5 === void 0 ? void 0 : _product$attributesRa5.key,
          'capacity-type': (_product$attributesRa6 = product.attributesRaw.find(function (attribute) {
            return attribute.name === 'capacity-type';
          })) === null || _product$attributesRa6 === void 0 ? void 0 : (_product$attributesRa7 = _product$attributesRa6.value) === null || _product$attributesRa7 === void 0 ? void 0 : _product$attributesRa7.key
        };
        deletePropertyIfValueEmptyOrUndefined(existingVariants);
        return existingVariants;
      });
    };
    var updateFilter = function updateFilter(filter) {
      var _selectedVariant$valu37;
      var _ref9 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref9$noHistory = _ref9.noHistory,
        noHistory = _ref9$noHistory === void 0 ? false : _ref9$noHistory;
      var query = _objectSpread(_objectSpread({}, configuration.value), filter);
      var oldSku = (_selectedVariant$valu37 = selectedVariant.value) === null || _selectedVariant$valu37 === void 0 ? void 0 : _selectedVariant$valu37.sku;
      deletePropertyIfValueEmptyOrUndefined(query);
      var isExisting = productsVariants().some(function (element) {
        return isEqual(element, query);
      });
      if (isExisting) {
        var routeWithQuery = {
          path: route.path,
          query: query
        };
        nextTick(function () {
          noHistory ? router.replace(routeWithQuery) : router.push(routeWithQuery);
        });
        watchOnce(selectedVariant, function (val) {
          if ((val === null || val === void 0 ? void 0 : val.sku) !== oldSku) {
            trackViewItem({
              variant: val,
              variantName: selectedVariantName.value,
              priceRegular: priceRegular.value,
              priceSpecial: priceSpecial === null || priceSpecial === void 0 ? void 0 : priceSpecial.value,
              qty: qty.value
            });
          }
        });
      } else {
        console.warn('Product variants combination does not exist in backend');
      }
    };
    var productAttributes = computed(function () {
      var _selectedVariant$valu38, _selectedVariant$valu39;
      var neededAttributes = ['type-de-cheveux', 'type-de-peaux', 'univers-olfactif', 'proprietes-beaute', 'proprietes-bien-etre'];
      return (_selectedVariant$valu38 = selectedVariant.value) === null || _selectedVariant$valu38 === void 0 ? void 0 : (_selectedVariant$valu39 = _selectedVariant$valu38.attributesRaw) === null || _selectedVariant$valu39 === void 0 ? void 0 : _selectedVariant$valu39.filter(function (_ref0) {
        var name = _ref0.name;
        return neededAttributes.includes(name);
      }).reduce(function (a, c) {
        return merge(a, _defineProperty({}, c.name, map(c.value, 'key')));
      }, {});
    });
    var _useKeyBenefits = useKeyBenefits({
        keyBenefitsAttributes: productAttributes,
        iconsLibraries: {
          iconLibraryProductEoGuideBenefit: 1,
          iconLibrarySkin: 2,
          libraryHairTypeIcon: 3,
          iconLibraryOlfactoryFamily: 4
        }
      }),
      keyBenefits = _useKeyBenefits.keyBenefits;
    watch(countItemsWithoutGift, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return shippingMethodsByLocation();
          case 2:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    })));
    var productLink = computed(function () {
      return route.fullPath;
    });
    var reassuranceText = computed(function () {
      var _productContent$value0, _productContent$value1, _productContent$value10;
      var content = (_productContent$value0 = (_productContent$value1 = productContent.value) === null || _productContent$value1 === void 0 ? void 0 : (_productContent$value10 = _productContent$value1.reassuranceText) === null || _productContent$value10 === void 0 ? void 0 : _productContent$value10.content) !== null && _productContent$value0 !== void 0 ? _productContent$value0 : [];
      return _objectSpread({}, content[0]);
    });
    var hasReassuranceText = computed(function () {
      return Object.keys(reassuranceText.value).length > 0;
    });
    var productPictures = computed(function () {
      var _productContent$value11, _productContent$value12, _selectedVariant$valu40;
      return isEssentialOilPage.value ? (_productContent$value11 = productContent.value) === null || _productContent$value11 === void 0 ? void 0 : (_productContent$value12 = _productContent$value11.imagesCarousel) === null || _productContent$value12 === void 0 ? void 0 : _productContent$value12.map(function (img) {
        var _img$fields$file;
        return {
          label: img.fields.title,
          url: (_img$fields$file = img.fields.file) === null || _img$fields$file === void 0 ? void 0 : _img$fields$file.url
        };
      }) : (_selectedVariant$valu40 = selectedVariant.value) === null || _selectedVariant$valu40 === void 0 ? void 0 : _selectedVariant$valu40.images;
    });
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return shippingMethodsByLocation();
          case 2:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    })));
    useLazyAsyncData("tracking-product-page-".concat(route.params.slug), function () {
      var _selectedVariant$valu41, _selectedVariant$valu42, _selectedVariant$valu43, _selectedVariant$valu44, _selectedVariant$valu45, _selectedVariant$valu46;
      if (fetchProductPromise.pending.value) return true;
      trackViewItem({
        variant: selectedVariant.value,
        variantName: selectedVariantName.value,
        priceRegular: priceRegular.value,
        priceSpecial: priceSpecial === null || priceSpecial === void 0 ? void 0 : priceSpecial.value,
        qty: qty.value
      });
      trackDynamicYieldEvent({
        name: 'view_item',
        properties: {
          value: gtmValue(priceRegular.value, priceSpecial === null || priceSpecial === void 0 ? void 0 : priceSpecial.value, false, qty.value),
          value_in_cents: gtmValue(priceRegular.value, priceSpecial === null || priceSpecial === void 0 ? void 0 : priceSpecial.value, true, qty.value),
          currency: (_selectedVariant$valu41 = selectedVariant.value) === null || _selectedVariant$valu41 === void 0 ? void 0 : (_selectedVariant$valu42 = _selectedVariant$valu41.price) === null || _selectedVariant$valu42 === void 0 ? void 0 : _selectedVariant$valu42.value.currencyCode,
          items: [{
            item_id: "SKU_".concat((_selectedVariant$valu43 = selectedVariant.value) === null || _selectedVariant$valu43 === void 0 ? void 0 : _selectedVariant$valu43.sku),
            item_sku: (_selectedVariant$valu44 = selectedVariant.value) === null || _selectedVariant$valu44 === void 0 ? void 0 : _selectedVariant$valu44.sku,
            item_name: selectedVariantName.value,
            discount: gtmDiscountValue(priceRegular.value, priceSpecial === null || priceSpecial === void 0 ? void 0 : priceSpecial.value, false),
            discount_in_cents: gtmDiscountValue(priceRegular.value, priceSpecial === null || priceSpecial === void 0 ? void 0 : priceSpecial.value, true),
            price: gtmPriceFormat(priceRegular.value),
            price_in_cents: gtmPriceFormat(priceRegular.value, true),
            currency: (_selectedVariant$valu45 = selectedVariant.value) === null || _selectedVariant$valu45 === void 0 ? void 0 : (_selectedVariant$valu46 = _selectedVariant$valu45.price) === null || _selectedVariant$valu46 === void 0 ? void 0 : _selectedVariant$valu46.value.currencyCode
          }]
        }
      });
      sendViewedProductEventToKlaviyo();
    }, {
      watch: [fetchProductPromise.pending],
      server: false
    });
    var close = function close() {
      if (!useIsMobile()) {
        items.value = false;
      }
    };
    var openCart = function openCart() {
      hideCartPopup();
      toggleCartSidebar();
    };
    watch([userLoading], function () {
      sendViewedProductEventToKlaviyo();
    });
    var productDescription = computed(function () {
      var _productContent$value13, _productContent$value14;
      return (_productContent$value13 = (_productContent$value14 = productContent.value) === null || _productContent$value14 === void 0 ? void 0 : _productContent$value14.description) !== null && _productContent$value13 !== void 0 ? _productContent$value13 : selectedVariantDescription.value;
    });

    /**
     * Sends a viewed product event to klaviyo.
     */
    function sendViewedProductEventToKlaviyo() {
      if (customerEmail.value && selectedVariantName.value) {
        var _productDescription$v, _selectedVariant$valu47, _selectedVariant$valu48, _selectedVariant$valu49;
        var truncateString = function truncateString(str, maxLength) {
          if (str.length <= maxLength) {
            return str;
          }
          return str.substring(0, maxLength);
        };
        var maxLength = 250;
        var truncatedDescription = truncateString((_productDescription$v = productDescription.value) !== null && _productDescription$v !== void 0 ? _productDescription$v : '', maxLength);
        var eventName = 'Viewed Product';
        var variantItems = variants.value.map(function (variant) {
          var _variant$price3, _variant$price3$value;
          var isProductOutOfStock = isOutOfStock(variant);
          return {
            id: variant === null || variant === void 0 ? void 0 : variant.id,
            productId: variant === null || variant === void 0 ? void 0 : variant._id,
            sku: variant === null || variant === void 0 ? void 0 : variant.sku,
            price: (variant === null || variant === void 0 ? void 0 : (_variant$price3 = variant.price) === null || _variant$price3 === void 0 ? void 0 : (_variant$price3$value = _variant$price3.value) === null || _variant$price3$value === void 0 ? void 0 : _variant$price3$value.centAmount) / 100,
            isInStock: !isProductOutOfStock
          };
        });
        var properties = {
          ProductId: "".concat((_selectedVariant$valu47 = selectedVariant.value) === null || _selectedVariant$valu47 === void 0 ? void 0 : _selectedVariant$valu47._id, "-").concat((_selectedVariant$valu48 = selectedVariant.value) === null || _selectedVariant$valu48 === void 0 ? void 0 : _selectedVariant$valu48.id),
          ProductName: selectedVariantName.value,
          ProductSku: (_selectedVariant$valu49 = selectedVariant.value) === null || _selectedVariant$valu49 === void 0 ? void 0 : _selectedVariant$valu49.sku,
          isInStock: !isOutOfStock(selectedVariant.value),
          ImageURL: getProductMainImage.value || '',
          ProductDescription: truncatedDescription,
          URL: productLink.value,
          Price: priceRegular.value || '',
          PriceDiscount: (priceSpecial === null || priceSpecial === void 0 ? void 0 : priceSpecial.value) || '',
          items: variantItems
        };
        klaviyoClientPushEvent(customerEmail.value, locale, properties, eventName);
      }
    }
    var _useIAdvize = useIAdvize(),
      setIAdvizeData = _useIAdvize.setIAdvizeData;
    var iAdvizeEnabled = $flag.get('iAdvizeEnabled');
    watch(selectedVariant, function (val) {
      if (iAdvizeEnabled && process.client && val) {
        var _val$_id;
        setIAdvizeData({
          page_type: 'product',
          product_id: (_val$_id = val._id) !== null && _val$_id !== void 0 ? _val$_id : ''
        });
      }
    }, {
      immediate: true
    });
    return {
      __sfc: true,
      route: route,
      router: router,
      country: country,
      currency: currency,
      locale: locale,
      isAuthenticated: isAuthenticated,
      user: user,
      userLoading: userLoading,
      AzExpandableText: AzExpandableText,
      isCustomizerFeatureEnabled: isCustomizerFeatureEnabled,
      app: app,
      error: error,
      i18n: i18n,
      $flag: $flag,
      $trackers: $trackers,
      client: client,
      fetchProducts: fetchProducts,
      fetchProductSeoContent: fetchProductSeoContent,
      fetchEODPSeoContent: fetchEODPSeoContent,
      masterVariant: masterVariant,
      variants: variants,
      selectedVariant: selectedVariant,
      selectedVariantPrice: selectedVariantPrice,
      selectedVariantName: selectedVariantName,
      selectedVariantDescription: selectedVariantDescription,
      productSeoContent: productSeoContent,
      idRawMaterialsReviews: idRawMaterialsReviews,
      skusForReviews: skusForReviews,
      isCustomerGroupWithoutVat: isCustomerGroupWithoutVat,
      masterVariantSku: masterVariantSku,
      productId: productId,
      fetchProductPromise: fetchProductPromise,
      setMeta: setMeta,
      getDomain: getDomain,
      defaultLocale: defaultLocale,
      getActualPrice: getActualPrice,
      socialMeta: socialMeta,
      setDynamicYieldContext: setDynamicYieldContext,
      setDynamicYieldContextSSR: setDynamicYieldContextSSR,
      trackDynamicYieldEvent: trackDynamicYieldEvent,
      fetchProductContent: fetchProductContent,
      productContent: productContent,
      relatedRecipes: relatedRecipes,
      relatedRecipesDescription: relatedRecipesDescription,
      relatedProductDescription: relatedProductDescription,
      relatedProductsSku: relatedProductsSku,
      relatedAdvices: relatedAdvices,
      isEssentialOil: isEssentialOil,
      isEssentialOilPage: isEssentialOilPage,
      updateSeoMeta: updateSeoMeta,
      contentLoading: contentLoading,
      formattedTitle: formattedTitle,
      tabs: tabs,
      bottomContent: bottomContent,
      bundleData: bundleData,
      bundleVariant: bundleVariant,
      isBundle: isBundle,
      productReviews: productReviews,
      fetchProductReviews: fetchProductReviews,
      reviewsTotalReviews: reviewsTotalReviews,
      reviewsTotalLocalReviews: reviewsTotalLocalReviews,
      reviewsAverageRating: reviewsAverageRating,
      items: items,
      hideCartPopup: hideCartPopup,
      toggleCartSidebar: toggleCartSidebar,
      cart: cart,
      countItemsWithoutGift: countItemsWithoutGift,
      getTotals: getTotals,
      isMobileView: isMobileView,
      isBookShop: isBookShop,
      qty: qty,
      customizerNeutralBase: customizerNeutralBase,
      getProductBreadcrumbs: getProductBreadcrumbs,
      freeShippingThreshold: freeShippingThreshold,
      shippingMethodsByLocation: shippingMethodsByLocation,
      isAddToCartModalOpen: isAddToCartModalOpen,
      toggleAddToCartModal: toggleAddToCartModal,
      addToCartPopup: addToCartPopup,
      isSticky: isSticky,
      isStickyDesktop: isStickyDesktop,
      refHookStickyAddToCartDesktop: refHookStickyAddToCartDesktop,
      refAddToCartPDP: refAddToCartPDP,
      trackViewItem: trackViewItem,
      observerForCtaStickyMobile: observerForCtaStickyMobile,
      observerForCtaStickyDesktop: observerForCtaStickyDesktop,
      initIntersectionObserver: initIntersectionObserver,
      customerEmail: customerEmail,
      priceRegular: priceRegular,
      priceSpecial: priceSpecial,
      options: options,
      configuration: configuration,
      inStockAttribute: inStockAttribute,
      isProductDiscontinuedAttribute: isProductDiscontinuedAttribute,
      isInStock: isInStock,
      isDiscontinued: isDiscontinued,
      isProductDiscontinued: isProductDiscontinued,
      isAvailableInCountry: isAvailableInCountry,
      isExpressDeliveryUnavailable: isExpressDeliveryUnavailable,
      breadcrumbs: breadcrumbs,
      merchLabels: merchLabels,
      totalCart: totalCart,
      freeShippingRemainingAmount: freeShippingRemainingAmount,
      freeShippingThresholdReached: freeShippingThresholdReached,
      freeShippingProduct: freeShippingProduct,
      freeShippingText: freeShippingText,
      hasLabels: hasLabels,
      isCustomizable: isCustomizable,
      defaultProductImage: defaultProductImage,
      getProductMainImage: getProductMainImage,
      relatedRecipesEl: relatedRecipesEl,
      scrollToRecipes: scrollToRecipes,
      getLabel: getLabel,
      ecoPart: ecoPart,
      generateVariantString: generateVariantString,
      portionLabel: portionLabel,
      isPortionLabelVisible: isPortionLabelVisible,
      pricePerUnit: pricePerUnit,
      productsVariants: productsVariants,
      updateFilter: updateFilter,
      productAttributes: productAttributes,
      keyBenefits: keyBenefits,
      productLink: productLink,
      reassuranceText: reassuranceText,
      hasReassuranceText: hasReassuranceText,
      productPictures: productPictures,
      close: close,
      openCart: openCart,
      productDescription: productDescription,
      sendViewedProductEventToKlaviyo: sendViewedProductEventToKlaviyo,
      setIAdvizeData: setIAdvizeData,
      iAdvizeEnabled: iAdvizeEnabled,
      sanitizeHtml: sanitizeHtml,
      AzLoader: AzLoader,
      SCHEMA_PRODUCT: SCHEMA_PRODUCT,
      NUMBER_OF_REVIEWS: NUMBER_OF_REVIEWS,
      AverageRatingCount: AverageRatingCount,
      WishlistButton: WishlistButton,
      AddToCartOverlay: AddToCartOverlay,
      TheTabs: TheTabs,
      Gallery: Gallery,
      BaseBreadcrumbs: BaseBreadcrumbs,
      VariantSelector: VariantSelector,
      AppBottomContent: AppBottomContent,
      HowToUse: HowToUse,
      AzEssentialOilGuideCard: AzEssentialOilGuideCard,
      AzBackToTopButton: AzBackToTopButton,
      ShareProduct: ShareProduct,
      RatingReviews: RatingReviews,
      RichText: RichText,
      InformationBox: InformationBox,
      InformationItem: InformationItem,
      TheBibliography: TheBibliography,
      ProductLabels: ProductLabels,
      MerchandisingLabels: MerchandisingLabels,
      BaseSingleBreadcrumb: BaseSingleBreadcrumb,
      BundleProductCard: BundleProductCard,
      KeyBenefits: KeyBenefits,
      RelatedProductsOrganism: RelatedProductsOrganism,
      RelatedRecipesOrganism: RelatedRecipesOrganism,
      RelatedAdvicesOrganism: RelatedAdvicesOrganism,
      UpsellProductsOrganism: UpsellProductsOrganism,
      AddToCartProductPage: AddToCartProductPage,
      ProductGallerySkeleton: ProductGallerySkeleton,
      ProductDescriptionSkeleton: ProductDescriptionSkeleton,
      ProductDescriptionMobileSkeleton: ProductDescriptionMobileSkeleton,
      ProductImageSkeleton: ProductImageSkeleton,
      getImgByLabel: getImgByLabel
    };
  }
});